import { HTTPResponse } from '@/services/http/http.types'
import { IMaintenanceEvent, TUnplannedMaintenanceEvent } from './calendar.types'
import http, { handleHttpResponse, handleHttpError } from '@/services/http'
import { IUser } from '../Users/users.types'

const getMaintenancePlansAllEquipment = async (params: {
  date_gte: string
  date_lte: string
  userId?: IUser['id']
}): Promise<HTTPResponse<IMaintenanceEvent[]>> => {
  return http.get(`/nsi/v1/maintenance/all-equipment-plan`, { params }).then(handleHttpResponse).catch(handleHttpError)
}

const getUnplannedMaintenanceEventsList = async (params: {
  date_gte: string
  date_lte: string
  userId?: IUser['id']
}): Promise<HTTPResponse<TUnplannedMaintenanceEvent[]>> => {
  return http.get('/nsi/v1/maintenance/unplanned-completed', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const calendarApi = { getMaintenancePlansAllEquipment, getUnplannedMaintenanceEventsList }

export default calendarApi
